import Vue from 'vue'
import Vuex from 'vuex'
import { api, userCart } from '@/global'
Vue.use(Vuex)

const state = {
  authenticated: false,
  sidebarMinimize: false,
  sidebarShow: 'responsive',
  user: {
    id: null,
    token: null,
    email: null,
  },
  forms: {
    collapsed: {
      apps: true,
      dados: true,
      aceite: true,
      dominio: true,
      logistica: true,
      aparencia: true,
      marketing: true,
      pagamento: true,
      atendimento: true,
      faturamento: true
    },
    show: {
      apps: true,
      dados: true,
      aceite: true,
      dominio: true,
      logistica: true,
      aparencia: true,
      marketing: true,
      pagamento: true,
      atendimento: true,
      faturamento: true
    }
  },
  itemsCart: {},
  apps: {},
  dados: {
    id: '',
    cnpj: '',
    cep: '',
    cidade: '',
    estado: '',
    numero: '',
    bairro: '',
    logradouro: '',
    razao_social: '',
    nome_fantasia: ''
  },
  aceite: {
    id: '',
    termo_aceite: ''
  },
  dominio: {
    id: '',
    menus: '',
    dominio: '',
    facebook: '',
    instagram: '',
    pinterest: '',
    autorization: ''
  },
  logistica: {
    id: '',
    frete_gratis: '',
    sigepweb_login: '',
    sigepweb_senha: '',
    cod_adm_correio: ''
  },
  aparencia: {},
  marketing: {
    id: '',
    pixel_facebook: '',
    google_analytics: ''
  },
  pagamento: {
    id: '',
    login: '',
    senha: '',
    parcelamento: '',
    meio_pagamento: '',
    parcela_minima: '',
    validate_boletos: ''
  },
  atendimento: {
    id: '',
    email: '',
    login: '',
    senha: '',
    telefone: '',
    plataforma: ''
  },
  faturamento: {
    id: '',
    erp: '',
    login: '',
    senha: '',
    senhacertificado: ''
  },
  notification: {}
}

const getters = {
  user (state) {
    return state.user
  },
  apps (state) {
    return state.apps
  },
  dados (state) {
    return state.dados
  },
  aceite (state) {
    return state.aceite
  },
  dominio (state) {
    return state.dominio
  },
  itemsCart (state) {
    return state.itemsCart
  },
  aparencia (state) {
    return state.aparencia
  },
  logistica (state) {
    return state.logistica
  },
  marketing (state) {
    return state.marketing
  },
  pagamento (state) {
    return state.pagamento
  },
  faturamento (state) {
    return state.faturamento
  },
  atendimento (state) {
    return state.atendimento
  },
  authenticated (state) {
    return state.authenticated
  },
  notification (state) {
    return state.notification
  },
  collapsed (state) {
    return state.forms.collapsed
  }
}

const mutations = {
  set (state, [variable, value]) {
    state[variable] = value
  },
  setUser (state, data) {
    state.user = data;
    if (data) {
      api.defaults.headers.Authorization = data.token;
    } else {
      delete api.defaults.headers.Authorization
    }
  },
  setUserCart (state, data) {
    console.log(data)
    state.itemsCart = data;
    if (data.Atendimento) {
      state.atendimento.plataforma = data.Atendimento.produto;
    }
    if (data.Faturamento) {
      state.faturamento.erp = data.Faturamento.produto;
    }
    if (data.Logística) {
      state.logistica.gateway = data.Logística.produto;
    }
    if (data.Pagamento) {
      state.pagamento.meio_pagamento = data.Pagamento.produto;
    }
    if (data.App) {
      const aplicativos = [];
      for (const key of data.App) {
        const app = {"name": key }
        aplicativos.push(app)
      }
      state.apps = aplicativos
    }
    console.log('store', state.apps)
  },
  toggleSidebarDesktop (state) {
    const sidebarOpened = [true, 'responsive'].includes(state.sidebarShow)
    state.sidebarShow = sidebarOpened ? false : 'responsive'
  },
  toggleSidebarMobile (state) {
    const sidebarClosed = [false, 'responsive'].includes(state.sidebarShow)
    state.sidebarShow = sidebarClosed ? true : 'responsive'
  },
  setAuthenticated (state, data) {
    state.authenticated = data
  },
  setAceite (state, data) {
    state.aceite = data
  },
  setAparencia (state, data) {
    state.aparencia = data
  },
  setApps (state, data) {
    state.apps = data
  },
  setAtendimento (state, data) {
    state.atendimento = data
  },
  setDados (state, data) {
    state.dados = data
  },
  setDominio (state, data) {
    state.dominio = data
  },
  setFaturamento (state, data) {
    state.faturamento = data
  },
  setLogistica (state, data) {
    state.logistica = data
  },
  setMarketing (state, data) {
    state.marketing = data
  },
  setPagamento (state, data) {
    state.pagamento = data
  },
  setNotification (state, data) {
    state.notification = data
  },
  setmessageSuccess(state) {
    state.notification = {
      show: true,
      message: 'Dados armazenados com sucesso',
      type: 'success',
      icon: true
    }
  },
  setmessageError(state) {
    state.notification = {
      show: true,
      message: 'Erro ao armazenar arquivos',
      type: 'danger',
      icon: true
    }
  },
  setCollapsed (state, data) {
    state.forms.collapsed[data] = false;
  },
  setCollapsedTrue (state, data) {
    state.forms.collapsed[data] = !state.forms.collapsed[data];
  }
}

const actions = {
  loadAceite (context) {
    api.get('/accept/id/' + state.user.id)
    .then(response => {
      context.commit('setAceite', response.data)
      context.dispatch('retract', 'aceite')
    });
  },
  loadAparencia (context) {
    api.get('/appearance/id/' + state.user.id)
    .then(response => {
      context.commit('setAparencia', response.data)
    });
  },
  loadApps (context) {
    api.get('/applications/id/' + state.user.id)
    .then(response => {
      context.commit('setApps', response.data)
    });
  },
  loadAtendimento (context) {
    api.get('/attendance/id/' + state.user.id)
    .then(response => {
      context.commit('setAtendimento', response.data)
    });
  },
  loadDados (context) {
    api.get('/datastore/id/' + state.user.id)
    .then(response => {
      context.commit('setDados', response.data)
    });
  },
  loadDominio (context) {
    api.get('/domain/id/' + state.user.id)
    .then(response => {
      context.commit('setDominio', response.data)
    });
  },
  loadFaturamento (context) {
    api.get('/billing/id/' + state.user.id)
    .then(response => {
      context.commit('setFaturamento', response.data)
    });
  },
  loadLogistica (context) {
    api.get('/logistics/id/' + state.user.id)
    .then(response => {
      context.commit('setLogistica', response.data)
    });
  },
  loadMarketing (context) {
    api.get('/marketing/id/' + state.user.id)
    .then(response => {
      context.commit('setMarketing', response.data)
    });
  },
  loadPagamento (context) {
    api.get('/payment/id/' + state.user.id)
    .then(response => {
      context.commit('setPagamento', response.data)
    });
  },
  async loadCartUser (context) {
    const json = localStorage.getItem(userCart)
    const userData = JSON.parse(json)
    if (!userData) {
      await api.get('/customer/itemscart/id/' + state.user.id)
      .then(response => {
        context.commit('setUserCart', response.data)
        localStorage.setItem(userCart, JSON.stringify(response.data))
      })
      .catch(error => {
      });
    } else {
      context.commit('setUserCart', userData)
    }
  },
  /*POST*/
  async saveTemoAceite(context, payload) {
    payload.id = state.user.id;
    await api.post('/accept', payload).then(response => {
      if (response.status === 201) {
        context.commit('setAceite', payload);
        context.commit('setmessageSuccess')
        context.commit('setCollapsed', 'aceite')
      }
    })
    .catch(error => {
      context.commit('setmessageError')
    })
  },
  async saveDadosLoja(context, payload) {
    payload.id = state.user.id;
    await api.post('/datastore', payload).then(response => {
      if (response.status === 201) {
        context.commit('setDados', payload);
        context.commit('setmessageSuccess')
        context.commit('setCollapsed', 'dados')
      }
    })
    .catch(error => {
      context.commit('setmessageError')
    })
  },
  async savePagamento(context, payload) {
    payload.id = state.user.id;
    await api.post('/payment', payload).then(response => {
      if (response.status === 201) {
        context.commit('setPagamento', payload);
        context.commit('setmessageSuccess')
        context.commit('setCollapsed', 'pagamento')
      }
    })
    .catch(error => {
      context.commit('setmessageError')
    })
  },
  async saveMarketing(context, payload) {
    payload.id = state.user.id;
    await api.post('/marketing', payload).then(response => {
      if (response.status === 201) {
        context.commit('setMarketing', payload);
        context.commit('setmessageSuccess')
        context.commit('setCollapsed', 'marketing')
      }
    })
    .catch(error => {
      context.commit('setmessageError')
    })
  },
  async saveLogistica(context, payload) {
    payload.id = state.user.id;
    await api.post('/logistics', payload).then(response => {
      if (response.status === 201) {
        context.commit('setLogistica', payload);
        context.commit('setmessageSuccess')
        context.commit('setCollapsed', 'logistica')
      }
    })
    .catch(error => {
      context.commit('setmessageError')
    })
  },
  async saveFaturamento(context, payload) {
    payload.id = state.user.id;
    await api.post('/billing', payload).then(response => {
      if (response.status === 201) {
        context.commit('setFaturamento', payload);
        context.commit('setmessageSuccess')
        context.commit('setCollapsed', 'faturamento')
      }
    })
    .catch(error => {
      context.commit('setmessageError')
    })
  },
  async saveDominio(context, payload) {
    payload.id = state.user.id;
    await api.post('/domain', payload).then(response => {
      if (response.status === 201) {
        context.commit('setDominio', payload);
        context.commit('setmessageSuccess')
        context.commit('setCollapsed', 'dominio')
      }
    })
    .catch(error => {
      context.commit('setmessageError')
    })
  },
  async saveAtendimento(context, payload) {
    payload.id = state.user.id;
    await api.post('/attendance', payload).then(response => {
      if (response.status === 201) {
        context.commit('setAtendimento', payload);
        context.commit('setmessageSuccess')
        context.commit('setCollapsed', 'atendimento')
      }
    })
    .catch(error => {
      context.commit('setmessageError')
    })
  },
  async saveAplicativos(context, payload) {
    payload.id = state.user.id;
    await api.post('/applications', payload).then(response => {
      if (response.status === 201) {
        context.commit('setApps', payload);
        context.commit('setmessageSuccess')
        context.commit('setCollapsed', 'apps')
      }
    })
    .catch(error => {
      context.commit('setmessageError')
    })
  },
  async saveAparencia(context, payload) {
    payload.id = state.user.id;
    await api.post('/appearance', payload).then(response => {
      if (response.status === 201) {
        context.commit('setAparencia', payload);
        context.commit('setmessageSuccess')
        context.commit('setCollapsed', 'aparencia')
      }
    })
    .catch(error => {
      context.commit('setmessageError')
    })
  },

  /*PUT*/
  async updateAccept(context, payload) {
    await api.put('/accept' + payload.id, payload)
    .then(response => {
      if (response.status === 201) {
        context.commit('setAceite', payload);
        context.commit('setmessageSuccess')
        context.commit('setCollapsed', 'aceite')
      }
    })
    .catch(error => {
      context.commit('setmessageError')
    })
  },
  async updateDatastore(context, payload) {
    await api.put('/datastore' + payload.id, payload)
    .then(response => {
      if (response.status === 201) {
        context.commit('setDados', payload);
        context.commit('setmessageSuccess')
        context.commit('setCollapsed', 'dados')
      }
    })
    .catch(error => {
      context.commit('setmessageError')
    })
  },
  async updatePayment(context, payload) {
    await api.put('/payment' + payload.id, payload)
    .then(response => {
      if (response.status === 201) {
        context.commit('setPagamento', payload);
        context.commit('setmessageSuccess')
        context.commit('setCollapsed', 'pagamento')
      }
    })
    .catch(error => {
      context.commit('setmessageError')
    })
  },
  async updateMarketing(context, payload) {
    await api.put('/marketing' + payload.id, payload)
    .then(response => {
      if (response.status === 201) {
        context.commit('setMarketing', payload);
        context.commit('setmessageSuccess')
        context.commit('setCollapsed', 'marketing')
      }
    })
    .catch(error => {
      context.commit('setmessageError')
    })
  },
  async updateLogistics(context, payload) {
    await api.put('/logistics' + payload.id, payload)
    .then(response => {
      if (response.status === 201) {
        context.commit('setLogistica', payload);
        context.commit('setmessageSuccess')
        context.commit('setCollapsed', 'logistica')
      }
    })
    .catch(error => {
      context.commit('setmessageError')
    })
  },
  async updateBilling(context, payload) {
    await api.put('/billing' + payload.id, payload)
    .then(response => {
      if (response.status === 201) {
        context.commit('setFaturamento', payload);
        context.commit('setmessageSuccess')
        context.commit('setCollapsed', 'faturamento')
      }
    })
    .catch(error => {
      context.commit('setmessageError')
    })
  },
  async updateDomain(context, payload) {
    await api.put('/domain' + payload.id, payload)
    .then(response => {
      if (response.status === 201) {
        context.commit('setDominio', payload);
        context.commit('setmessageSuccess')
        context.commit('setCollapsed', 'dominio')
      }
    })
    .catch(error => {
      context.commit('setmessageError')
    })
  },
  async updateAttendance(context, payload) {
    await api.put('/attendance' + payload.id, payload)
    .then(response => {
      if (response.status === 201) {
        context.commit('setAtendimento', payload);
        context.commit('setmessageSuccess')
        context.commit('setCollapsed', 'atendimento')
      }
    })
    .catch(error => {
      context.commit('setmessageError')
    })
  },
  async updateApplications(context, payload) {
    await api.put('/applications'+ payload.id, payload)
    .then(response => {
      if (response.status === 201) {
        context.commit('setApps', payload);
        context.commit('setmessageSuccess')
        context.commit('setCollapsed', 'apps')
      }
    })
    .catch(error => {
      context.commit('setmessageError')
    })
  },
  async updateAppearance(context, payload) {
    await api.put('/appearance' + payload.id, payload)
    .then(response => {
      if (response.status === 201) {
        context.commit('setAparencia', payload);
        context.commit('setmessageSuccess')
        context.commit('setCollapsed', 'aparencia')
      }
    })
    .catch(error => {
      context.commit('setmessageError')
    })
  },
  retract(context, data) {
    const payload = state[data]
    const keys = Object.keys(payload);
    let count = 0;
    if (keys.length > 0) {
      keys.forEach(key => {
        if(payload[key] === undefined || payload[key] === "" || payload[key] === null) {
          count++
        }
      });
      if (count == 0) {
        context.commit('setCollapsedTrue', data)
      }
    }
  }
}
export default new Vuex.Store({
  state,
  actions,
  getters,
  mutations,
})
